/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CustomerSpecificPricingAgreementStatus {
  Draft = "draft",
  PricingRequested = "pricing_requested",
  Finalizing = "finalizing",
  Live = "live",
  Cancelled = "cancelled",
  CarrierDeclined = "carrier_declined",
  ExistingCustomer = "existing_customer",
}

export function instanceOfCustomerSpecificPricingAgreementStatus(
  value: any,
): boolean {
  for (const key in CustomerSpecificPricingAgreementStatus) {
    if (
      Object.prototype.hasOwnProperty.call(
        CustomerSpecificPricingAgreementStatus,
        key,
      )
    ) {
      if (
        CustomerSpecificPricingAgreementStatus[
          key as keyof typeof CustomerSpecificPricingAgreementStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CustomerSpecificPricingAgreementStatusFromJSON(
  json: any,
): CustomerSpecificPricingAgreementStatus {
  return CustomerSpecificPricingAgreementStatusFromJSONTyped(json, false);
}

export function CustomerSpecificPricingAgreementStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerSpecificPricingAgreementStatus {
  return json as CustomerSpecificPricingAgreementStatus;
}

export function CustomerSpecificPricingAgreementStatusToJSON(
  value?: CustomerSpecificPricingAgreementStatus | null,
): any {
  return value as any;
}

export function CustomerSpecificPricingAgreementStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CustomerSpecificPricingAgreementStatus {
  return value as CustomerSpecificPricingAgreementStatus;
}
